import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Document, DocumentListItem} from '../models/document.model';
import {map} from 'rxjs/operators';
import {getHttpParams} from '../helpers/request.helper';
import {DocumentListFilter} from '../models/document-list-filter.model';
import {mapSearchListResponse} from '../helpers/search.helper';
import {SearchQueryParams} from '../models/search-query-params.model';

@Injectable()
export class DocumentService {
    baseUrl = '/api/secured/documents';

    constructor(
        private http: HttpClient
    ) {}

    fetchList(props: SearchQueryParams) {
        return this.http
            .get<Document[]>(this.baseUrl, {params: props.getHttpParams(), observe: 'response'})
            .pipe(mapSearchListResponse<Document>(Document));
    }

    fetchSimpleList(params: DocumentListFilter) {
        return this.http
            .get<Document[]>(`${this.baseUrl}/simple`, {params: getHttpParams(params), observe: 'response'})
            .pipe(map(response => response.body));
    }

    fetchById(id: number) {
        return this.http.get<Document>(`${this.baseUrl}/${id}`);
    }

    add(document: Document) {
        return this.http.post(this.baseUrl, {...document});
    }

    update(document: Document) {
        return this.http.put(`${this.baseUrl}/${document.id}`, {...document});
    }

    delete(document: Document) {
        return this.http.delete(`${this.baseUrl}/${document.id}`);
    }

    getOwuList() {
        return this.http.get<DocumentListItem[]>(`${this.baseUrl}/simple?category=OWU`);
    }

    getPolicyAttachmentList() {
        return this.http.get<DocumentListItem[]>(`${this.baseUrl}/simple?policyAttachment=true`);
    }
}
